// Module
var code = `<div class="change-password-screen">
    <div class="change-password-screen-selector">
        <div class="change-password-screen-selector-content">
            <terceraLabel text="{{.curPwdLabel}}" />
            <passwordTextBox placeholder="{{.curPwdPlaceholder}}" text="{{.curPwd}}" showPasswordPreview="{{.allowPreviewPassword}}" isMaterialDesign="false" />
        </div>

        <div class="change-password-screen-selector-content">
            <terceraLabel text="{{.newPwdLabel}}" />
            <passwordTextBox placeholder="{{.newPwdPlaceholder}}" text="{{.newPwd}}" showPasswordPreview="{{.allowPreviewPassword}}" isMaterialDesign="false" />
        </div>

        <div class="change-password-screen-selector-content">
            <terceraLabel text="{{.newPwdConfirmLabel}}" />
            <passwordTextBox placeholder="{{.newPwdConfirmPlaceholder}}" text="{{.newPwdConfirm}}" showPasswordPreview="{{.allowPreviewPassword}}" isMaterialDesign="false" />
        </div>
    </div>

    <div class="change-password-screen-footer">
        <terceraButton terceraButtonStyle="{{.btnOKStyle}}" text="{{.okText}}" on-btnClick="ok" />
        <terceraButton terceraButtonStyle="{{.btnCancelStyle}}" text="{{.cancelText}}" on-btnClick="cancel" />
    </div>
</div>`;
// Exports
export default code;